


import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import firebase from 'lib/firebase';
import ClipLoader from "react-spinners/ClipLoader";
import { Container, Col, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import moment from 'moment';
import axios from 'axios';

import * as AdminActions from 'store/modules/AdminModule';

import api from 'lib/api';
import global from 'lib/global';

import Pagination from './Pagination';

class FilesScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            isTabType: 0,
            isImageIdx: 0,
            fileLoading: false, //피일 업로드중인지
            files: undefined,
            isLevel: null,
            isRound: null,
        }
    }

    componentDidMount() {
        this.props.adminActions.getAdminFileList({
            page: 0,
            type: 0,
        })
    }

    onChangePage = (pageIdx) => {
        this.props.adminActions.getAdminFileList({
            page: pageIdx,
            type: this.state.isTabType,
        })
        this.setState({ page: pageIdx })
    }

    onEditFile = (e, row, rowIndex) => {
        this.setState({
            isImageIdx: row.idx,
            isLevel: row.level,
            isRound: row.round,
        })
    }

    onClickFilter = (tabType) => {
        this.props.adminActions.getAdminFileList({
            page: 0,
            type: tabType,
        })
        this.setState({ isTabType: tabType })
    }

    onChangeLevel = (e) => {
        this.setState({ isLevel: e.target.value })
    }

    onChangeRound = (e) => {
        this.setState({ isRound: e.target.value })
    }

    handleAttachFile = (e) => {
        this.setState({ files: e.target.files });
    }

    onClickUpload = () => {
        this.uploadImage(this.state.files);
    }

    uploadImage = async (files) => {
        if (this.state.fileLoading) {
            return;
        }

        if (!files || files.length == 0) {
            alert("파일을 첨부해주세요");
            return;
        }

        const self = this;

        const url = global.url_api + '/workbook/fileUpload/templateUpload';
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file[]', files[i]);
        }
        formData.append('idx', this.state.isImageIdx);
        formData.append('level', this.state.isLevel);
        formData.append('round', this.state.isRound);

        var user = firebase.auth().currentUser;
        let token = await user.getIdToken()

        const config = {
            headers: {
                'accept': 'application/json',
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token
            }
        }

        this.setState({ fileLoading: true });
        axios.post(url, formData, config)
            .then(function (response) {

                self.setState({ fileLoading: false });
                let data = response.data;
                if (data.result) {
                    //성공
                    self.props.adminActions.getAdminFileList({
                        page: self.state.page,
                        type: self.state.isTabType,
                    })
                    self.setState({
                        isImageIdx: 0,
                        isLevel: '',
                        isRound: '',
                        files: undefined,
                    });
                    document.getElementById('file').value = "";
                } else {
                    //실패
                    alert("실패했습니다.");
                }
            })
            .catch(function (err) {
                self.setState({ fileLoading: false });
            })
    };

    tableCellLevelFormatter = (cell) => {
        let levelList = ['무료 초급', '무료 중고급', '유료 초급', '유료 중고급', '보너스 단어', '유료 초급2'];

        return (
            <div>{levelList[cell - 1]}</div>
        )
    }

    tableCellFileNameFormatter = (cell) => {
        let fileName = cell.replace('https://boomco-email.s3.ap-northeast-2.amazonaws.com/workbook/', '');

        return (
            <div className='fileNameRowContainer'>
                <div className='buttonShowFile'>
                    <a href={cell} target={'_blank'}>확인하기</a>
                </div>
                <div>{fileName}</div>
            </div>
        )
    }


    render() {
        const filesData = this.props.adminFileList.list ? this.props.adminFileList.list : [];
        const self = this;
        let tabList = ['전체', '무료 초급', '무료 중고급', '유료 초급', '유료 중고급', '보너스 단어', '유료 초급2']
        let LayoutTabs = [];
        tabList.forEach(function (item, index) {
            let layoutItem = <li onClick={() => self.onClickFilter(index)} style={self.state.isTabType == index ? { background: '#97d4e7' } : null}>{tabList[index]}</li>
            
            LayoutTabs.push(layoutItem)
        })

        return (
            <div id='files'>
                <div id='filesHeader'>
                    <ul>
                        {LayoutTabs}
                    </ul>
                </div>

                <div id='functionContainer'>
                    <div className='imageUploader'>
                        <div>idx :</div>
                        <div className='imageIdx'>{this.state.isImageIdx}</div>
                        <div>level :</div>
                        <input type="number" value={this.state.isLevel}
                            min={1} max={6}
                            onChange={(e) => this.onChangeLevel(e)}
                            disabled={this.state.isImageIdx > 0 ? true : false} />
                        <div>round :</div>
                        <input type="number" value={this.state.isRound}
                            min={1}
                            onChange={(e) => this.onChangeRound(e)}
                            disabled={this.state.isImageIdx > 0 ? true : false} />
                        <input id="file" type="file" multiple style={{ color: '#666' }}
                            onChange={(e) => this.handleAttachFile(e)} />
                        {!this.state.fileLoading ?
                            <div className='buttonUpload' onClick={() => this.onClickUpload()}>{this.state.isImageIdx > 0 ? 'SAVE' : 'ADD'}</div>
                            : null
                        }
                        <ClipLoader
                            loader={"FadeLoader"}
                            color={'#0013c0'}
                            loading={this.state.fileLoading}
                            css={{marginRight: 40 }}
                            size={20}
                            className={"loader"} />
                    </div>
                    {/* 페이지 */}
                    <Pagination
                        maxPage={this.props.adminFileList.page_all ? this.props.adminFileList.page_all : 0}
                        isPage={this.state.page}
                        onPagination={this.onChangePage} />
                </div>

                <div id='table'>
                    <BootstrapTable
                        keyField='idx'
                        classes='table'
                        headerWrapperClasses='tableHeader'
                        bodyClasses='tableBody'
                        bordered={true}
                        data={filesData}
                        columns={[
                            {
                                dataField: 'idx', text: 'No',
                                headerClasses: 'table_width60', classes: 'table_width60',
                            },
                            {
                                dataField: 'level', text: 'Level',
                                headerClasses: 'table_width200', classes: 'table_width200',
                                formatter: this.tableCellLevelFormatter
                            },
                            {
                                dataField: 'round', text: 'Round',
                                headerClasses: 'table_width100', classes: 'table_width100',
                            },
                            {
                                dataField: 'file_name', text: 'File Name',
                                headerStyle: { textAlign: 'center' },
                                formatter: this.tableCellFileNameFormatter
                            },
                        ]}
                        rowEvents={{
                            onClick: (e, row, rowIndex) => this.onEditFile(e, row, rowIndex)
                        }} />
                </div>
            </div>
        );
    }
}



let mapStateToProps = (state) => ({
    adminFileList: JSON.parse(JSON.stringify(state.AdminModule.get('adminFileList'))),
});

let mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(AdminActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilesScreen);

